import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ConverterService,
  OccEndpointsService,
  UserIdService,
} from '@spartacus/core'
import { OrderModule } from '@spartacus/order'
import { OccOrderAdapter } from '@spartacus/order/occ'
import { Observable, of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import { SalesDocumentList } from '../../interfaces/eb-order.interface'

@Injectable({
  providedIn: OrderModule
})
export class EbOrderAdapter extends OccOrderAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
    protected occEndpointsService: OccEndpointsService,
    private readonly userIdService: UserIdService
  ) {
    super(http, occEndpoints, converter)
  }

  getOrdersForCurrentUser(currentPage: number, pageSize: number): Observable<SalesDocumentList> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.userIdService.getUserId().pipe(
      map(userId =>
        this.occEndpoints.buildUrl('orders', {
          urlParams: { userId },
          queryParams: { currentPage, pageSize }
        })
      ),
      switchMap(url => this.http.post<SalesDocumentList>(url, {}, { headers })),
      catchError(() => of({} as SalesDocumentList))
    )
  }

  downloadOrderDocument(userId: string, customerId: string, documentId: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.get(
      this.occEndpointsService.buildUrl('downloadOrderDocument', {
        urlParams: { userId },
        queryParams: {
          documentId,
          customerId
        }
      }),
      {
        responseType: 'blob',
        headers
      }
    )
  }
}
